import { ClassType, EntityStatusBadgeVariant } from '@frontend/common';
import { EntityStatusBadge } from '@frontend/components/badge';
import React from 'react';

export interface StatusBadgeProps<T> {
    value?: React.ReactNode;
    colorMap: Map<StatusBadgeProps<T>['value'][], ClassType>;
    displayMap?: Map<StatusBadgeProps<T>['value'], string>;
    textSize?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
}

const CLASS_TYPE_TO_VARIANT: Record<ClassType, EntityStatusBadgeVariant> = {
    [ClassType.SUCCESS]: EntityStatusBadgeVariant.Completed,
    [ClassType.WARNING]: EntityStatusBadgeVariant.AwaitingDropOff,
    [ClassType.INFO]: EntityStatusBadgeVariant.AwaitingPickUp,
    [ClassType.DANGER]: EntityStatusBadgeVariant.Failed,
    [ClassType.DISABLED]: EntityStatusBadgeVariant.Cancelled,
    [ClassType.SECONDARY]: EntityStatusBadgeVariant.Cancelled,
    [ClassType.DARK]: EntityStatusBadgeVariant.Draft,
    [ClassType.PRIMARY]: EntityStatusBadgeVariant.Draft,
    [ClassType.LIGHT]: EntityStatusBadgeVariant.Cancelled,
    [ClassType.DEBUG]: EntityStatusBadgeVariant.AwaitingPickUp,
    [ClassType.ALERT]: EntityStatusBadgeVariant.AwaitingDropOff
};

export const StatusBadge = <T extends any>(props: StatusBadgeProps<T>) => {
    if (!props.value) {
        return <></>;
    }

    const classType = getValueFromArrayMap(props.colorMap, props.value);
    const variant = CLASS_TYPE_TO_VARIANT[classType] ?? EntityStatusBadgeVariant.Draft;

    return (
        <EntityStatusBadge
            label={props.displayMap?.get(props.value) ?? props.value}
            variant={variant}
        />
    );
};

function getValueFromArrayMap<T>(map: Map<T[], ClassType>, value: T): ClassType {
    for (const [k, v] of map) {
        if (k.includes(value)) return v;
    }
    return ClassType.PRIMARY;
}
